import { TintColor } from "gen/tintcolor/models_pb"
import { useMemo } from "react"
import { useIdFilter } from "shared-ts/hooks/useFilter"

import { useSearchTintColors } from "features/api/search"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export function useTintColorFilter({
  persistInUrl = true,
}: Pick<UseWebFilterProps<unknown>, "persistInUrl"> = {}) {
  const { results, setQuery } = useSearchTintColors()

  const tintColors = useMemo(() => {
    const tintColors: TintColor[] = []
    for (const { tintColor } of results) {
      if (!tintColor) continue
      tintColors.push(tintColor)
    }
    return tintColors
  }, [results])

  const { filter, selected: selectedTintColorIds } = useIdFilter({
    key: "tintColor",
    label: "Tint Color",
    values: tintColors,
    sort: (a, b) => a.name.localeCompare(b.name),
    labelExtractor: (c) => `${c.name} (${c.code})`,
    onChangeQuery: setQuery,
    autoFilterOptions: false,
    allowExternalValues: true,
    useFilter: (props) => {
      return useWebFilter({
        ...props,
        persistInUrl,
      })
    },
  })

  return { filter, selectedTintColorIds }
}
